<template>
    <Transition name="mini-ticket-transition" v-if="isMobile">
        <div class="mini-ticket-preview" v-show="showTicketPreview">
            <div>
                <p class="mini-ticket__label">Vklad</p>
                <span class="mini-ticket__value">{{ stake }}</span>
            </div>
            <div>
                <p class="mini-ticket__label">Kurz</p>
                <span class="mini-ticket__value">{{ totalRate }}</span>
            </div>
            <div v-if="ticketStore.bonusPercent">
                <p class="mini-ticket__label">Výhra navíc</p>
                <span class="mini-ticket__value">
                    <img src="/shared-img/prematch/3d-gift.png" alt="Výhra navíc" width="13" height="16" />+{{ ticketStore.bonusPercent }}%
                </span>
            </div>
            <div>
                <p class="mini-ticket__label">Možná výhra</p>
                <span class="mini-ticket__value">{{ possibleWin }}</span>
            </div>
        </div>
    </Transition>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useTicketStore } from "@/ticket/stores/use-ticket-store";
import useUtils from "@/shared/composables/use-utils";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";

const ticketStore = useTicketStore();

const route = useRoute();

const { formatRate, formatPrice } = useUtils();

const { isMobile } = useIsBreakpoint();

const previewVisibleDuration = 2000;

const totalRate: ComputedRef<string> = computed(() => formatRate(ticketStore.potentialPayout));

const possibleWin: ComputedRef<string> = computed(() => formatPrice(ticketStore.possibleWin));

const stake: ComputedRef<string> = computed(() => formatPrice(ticketStore.ticketStake));

const showTicketPreview = ref(false);

let timeout = null;

watch(
    () => ticketStore.outcomeIds,
    (newValue, oldValue) => {
        if ((oldValue?.length >= 2 || newValue?.length >= 2) && newValue?.length) {
            showTicketPreview.value = true;

            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(() => {
                showTicketPreview.value = false;
            }, previewVisibleDuration);
        } else {
            showTicketPreview.value = false;
        }
    },
);

watch(route, () => {
    showTicketPreview.value = false;
});
</script>
